/**
 * Create OrderMethod context for custom hook
 */

import { createContext } from 'react'

const OrderMethodContext = createContext({
  setDeliveryAddress: () => {},
  setOrderMethod: () => {},
  setStore: () => {},
  deliveryAddress: {},
  orderMethod: {},
  store: {}
})

export default OrderMethodContext
